import request from '@/utils/request'

export function login(data) {
    return request({
        url: 'admin/auth/login',
        method: 'post',
        data
    })
}
export function logout(data={}) {
    return request({
        url: 'admin/auth/logout',
        method: 'post',
        data
    })
}
export function getAuth(query = {}) {
    return request({
        url: 'admin/auth/getMenuPermissions',
        method: 'get',
        params: query
    })
}
export function changePassword(data={}) {
    return request({
        url: 'admin/auth/changePassword',
        method: 'post',
        data
    })
}